/**
 *
 * Dashboard
 *
 */

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Swal from 'sweetalert2';
import $ from 'jquery';
import { swalWarning } from '@/utils/swal2';

import TrackerButton from '@/components/TrackerButton.vue';
import WayFindBar from '@/components/WayFindBar.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
import Ai from '@/components/Ai.vue';
import Player from '@/components/Player.vue';
import TabBar from '@/components/TabBar.vue';
import Spinner from '@/components/Spinner.vue';
import PzButton from '@/components/PzButton.vue';
import { ReopenInfoMixin } from '@/scripts/Dashboard/mixins/ReopenInfo';
import emailPic from '@handl-web/pz-ui/img/placeholder.jpg';
import { LOADING_MESSAGE } from './Dashboard.constants';
import {
  MAIN_MODE_COURSE_PAGE,
  MINI_MODE_COURSE_PAGE,
  FREE_MODE_COURSE_PAGE,
  FLASH_CARD_LANDING_PAGE,
  EXERCISE_PAGE,
} from '../../constants/routes';
import { REDIRECT_URLS } from '@/constants';

export default {
  name: 'Dashboard',

  components: {
    WayFindBar,
    Footer,
    Aside,
    Ai,
    Player,
    TabBar,
    Spinner,
    PzButton,
    TrackerButton,
  },

  mixins: [ReopenInfoMixin],

  data: () => {
    return {
      REDIRECT_URLS,
      DeferInfo: null,
      PreOpenInfo: null,
      loadingMessage: LOADING_MESSAGE,
      show: false,
      CoursePage: MAIN_MODE_COURSE_PAGE,
      MiniCoursePage: MINI_MODE_COURSE_PAGE,
      FreeCoursePage: FREE_MODE_COURSE_PAGE,
      FlashCardPage: FLASH_CARD_LANDING_PAGE,
      ExercisePage: EXERCISE_PAGE,
      currentCourseId: 0,
      optType: 0,
      isTooLarge: false,
      isEmailPicReady: false,
      emailPicDataUrl: emailPic,
      showAlert: true,
      isShowPlayer: false,
    };
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),

    ...mapState('Dashboard', {
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters({
      Courses: 'Dashboard/Courses',
      mainGroup: 'Dashboard/mainGroup',
      Mocks: 'Dashboard/Mocks',
      financeGroup: 'Dashboard/financeGroup',
      eventGroup: 'Dashboard/eventGroup',
      LastPlayedRecord: 'Dashboard/LastPlayedRecord',
      Pinzhibo: 'Dashboard/Pinzhibo',
      userInfo: 'userInfo',
      mg_identificationStatus: 'identificationStatus',
      immLoading: 'immLoading',
      aopLoading: 'aopLoading',
    }),

    ...mapGetters('AI', {
      mg_selectedAiHistoryVideo: 'selectedAiHistoryVideo',
      mg_selectedAiHistoryVideoNextBulletId: 'selectedAiHistoryVideoNextBulletId',
    }),
  },

  filters: {
    fixCompleteRate: (v) => (!v ? 0 : Math.floor(v * 10000) / 100),
    fixCompleteRateInv: (v) => (!v ? 0 : Math.floor(1000 / v) / 10),
  },

  mounted() {
    window.scrollTo(0, 0);
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },

  updated() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },

  created() {
    if (!this.userInfo.unLogin) {
      this.$store.dispatch('Dashboard/getCourses');
      if ('true' === window.localStorage.getItem('isLoginNotDashboard')) {
        this.ma_getImportantMessage();
        window.localStorage.removeItem('isLoginNotDashboard');
      }
    }
  },

  methods: {
    ...mapMutations({
      mm_SET_GOTO_LAST_STUDY: 'SET_GOTO_LAST_STUDY',
    }),

    ...mapMutations('AI', {
      mm_SET_SELECTED_BULLET_ID: 'SET_SELECTED_BULLET_ID',
      mm_SET_SELECTED_AI_HISTORY_RES_IDX: 'SET_SELECTED_AI_HISTORY_RES_IDX',
    }),

    ...mapActions({
      ma_getImportantMessage: 'getImportantMessage',
    }),

    ...mapActions({
      openUpCourse: 'Dashboard/openUpCourse',
      putOff: 'Dashboard/putOff',
      preOpen: 'Dashboard/preOpen',
    }),

    closeAlert() {
      this.showAlert = false;
    },

    postpone(courseId) {
      if (
        courseId == 62692 ||
        courseId == 62956 ||
        courseId == 63073 ||
        courseId == 65252 ||
        courseId == 65406
      ) {
        return true;
      } else {
        return false;
      }
    },

    openUpCPA(courseId) {
      this.currentCourseId = courseId;
      if (!this.aopLoading) {
        Swal.fire({
          title: '课程开通说明',
          text: `课程一旦开通，下一期考试如重修，需要提供前次考期的成绩单，申请重读。前次考试未报名，弃考，不出考无法申请重修。`,
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: '确定开通',
          cancelButtonText: '取消',
        }).then((result) => {
          if (result.value) {
            this.openUpCourse({ courseId });
          }
        });
      }
    },

    goTo() {
      this.$store.dispatch('Dashboard/getCourses');
    },

    choosePreOpen(preOpen) {
      this.PreOpenInfo = preOpen;
      $('#PreOpenModal').modal('show');
    },

    closePreOpen() {
      $('#PreOpenModal').modal('hide');
    },

    cancelPreOpen() {
      const _this = this;
      Swal.fire({
        title: '确定暂不申请开通下一级别课程？',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async (result) => {
        if (result.value) {
          $('#PreOpenModal').modal('hide');
          await _this.preOpen({ preopenId: _this.PreOpenInfo.preopenId, preopen: false });
          Swal.fire({
            width: '400px',
            backdrop: false,
            icon: 'success',
            title: `提交成功`,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
    },

    submitPreOpen() {
      const _this = this;
      Swal.fire({
        title: '确定申请开通下一级别课程？',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async (result) => {
        if (result.value) {
          $('#PreOpenModal').modal('hide');
          await _this.preOpen({ preopenId: _this.PreOpenInfo.preopenId, preopen: true });
          Swal.fire({
            width: '400px',
            backdrop: false,
            icon: 'success',
            title: `提交成功`,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
    },

    choosePutOff(deferInfo) {
      this.DeferInfo = deferInfo;
      $('#putOffModal').modal('show');
    },

    closePutOff() {
      $('#putOffModal').modal('hide');
    },

    submitPutOff() {
      const type = this.optType;
      const optionKey = this.DeferInfo.options[type].optionKey;
      const courseId = this.DeferInfo.courseId;
      const deferId = this.DeferInfo.options[type].deferId;
      if (this.DeferInfo.options[type].needProve && !this.isEmailPicReady) {
        Swal.fire({
          width: '400px',
          backdrop: false,
          icon: 'warning',
          text: '请您先上传延考截图。',
          title: `提交失败了`,
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }

      const formData = new FormData();
      formData.append('optionKey', optionKey);
      formData.append('courseId', courseId);
      formData.append('deferId', deferId);

      if (this.DeferInfo.options[type].needProve && this.isEmailPicReady) {
        formData.append('file', this.$refs.emailPicInput.files[0]);
      } else {
        formData.append('file', null);
      }
      Swal.fire({
        title: '确定设置延考日期？',
        text: this.DeferInfo.options[type].optionReminder,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async (result) => {
        if (result.value) {
          $('#putOffModal').modal('hide');
          await this.putOff(formData);

          Swal.fire({
            width: '400px',
            backdrop: false,
            icon: 'success',
            title: `提交成功`,
            showConfirmButton: false,
            timer: 3000,
          });
          this.$refs.emailPicForm.reset();
          this.emailPicDataUrl = emailPic;
        }
      });
    },

    handleClickEmailPicBtn() {
      this.$refs.emailPicInput.click();
    },

    handleChangeEmailPic() {
      const fileReader = new FileReader();
      const file = this.$refs.emailPicInput.files[0];
      this.isTooLarge = file.size > 5 * 1024 * 1024;
      fileReader.readAsDataURL(file);
      fileReader.onload = (e) => {
        this.emailPicDataUrl = e.target.result;
      };
      this.isEmailPicReady = !(
        undefined === this.$refs.emailPicInput ||
        0 === this.$refs.emailPicInput.files.length ||
        this.isTooLarge
      );
    },

    hintCantLearnPzCourse(cantLearnPzCourseMessage) {
      Swal.fire({
        width: '400px',
        backdrop: true,
        icon: 'warning',
        //text: cantLearnPzCourseMessage,
        title: cantLearnPzCourseMessage,
        //showCancelButton: true,
        confirmButtonColor: '#3085d6',
        //cancelButtonColor: '#d33',
        confirmButtonText: '确定',
        //cancelButtonText: '取消',
      })/* .then((result) => {
        if (result.value) {
          this.choosePutOff(deferInfo);
        }
      }) */;
      return;
    },

    hint(deferInfo) {
      this.DeferInfo = deferInfo;
      Swal.fire({
        width: '400px',
        backdrop: true,
        icon: 'warning',
        text: deferInfo.deferInfo,
        title: `请先设置您的延考日期`,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '立即设置',
        cancelButtonText: '取消',
      }).then((result) => {
        if (result.value) {
          this.choosePutOff(deferInfo);
        }
      });
      return;
    },

    hintNoFlashCard() {
      swalWarning('该课程没有闪卡');
    },

    hintUnpaidFlashCard() {
      swalWarning('未购买这门课程的闪卡');
    },

    hintCardNotReady() {
      swalWarning('暂时还没有闪卡');
    },

    hintUnPaidQuestionLib() {
      swalWarning('您未购买该课程题库');
    },

    openPlayer(video) {
      this.mm_SET_SELECTED_BULLET_ID(video.bulletId);
      this.mm_SET_SELECTED_AI_HISTORY_RES_IDX(video.idxAiHistoryRes);
      this.isShowPlayer = true;
    },

    goToNextVideo() {
      this.mm_SET_SELECTED_BULLET_ID(this.mg_selectedAiHistoryVideoNextBulletId);
    },

    closePlayer() {
      this.isShowPlayer = false;
    },

    //toBuy(course) {
    //  let path = '';
    //  if (course.cssClassName.indexOf('cpa') != -1) {
    //    path = `/mall/cpa`;
    //  } else {
    //    path = `/mall/${course.cssClassName.replace('-', '')}`;
    //  }
    //  this.$router.push(path);
    //},
    toBuy() {
      window.location.href = 'https://www.pzacademy.com/';
    },

    gotoLastStudy(path) {
      this.mm_SET_GOTO_LAST_STUDY(true);
      this.$router.push(path);
    },

    gotoCourse(course) {
      let path;
      if (!course.planInfo) {
        path = `${this.CoursePage}/${course.courseId}`;
        path = 'ESG' !== course.category ? `${path}/challenge-mode` : `${path}/video-mode`;
        this.$router.push(path);
      } else {
        path = `/career/${course.planInfo.planId}`;
        this.$router.push(path);
      }
    },
  },
};
